import http from '../../utils/http.js';
export default {
	/**
	 * 通用请求
	 *
	 * @param {*} data
	 * @returns
	 */
	HtppRequest(url, method, data, success, fail) {
		return http({
			url: url,
			data: data,
			method: method,
			headers: {
				notShowError: true,
				showLoading: false
			}
		}).then(res => {
			success(res);
		}).catch(err => {
			fail(err);
		});
	},
	HttpGet(url, params, success, fail) {
		return http({
			url,
			method: 'get',
			params,
			headers: {
				notShowError: true,
				showLoading: false
			}
		}).then(res => {
			success(res);
		}).catch(err => {
			fail(err);
		});
	}

};
